import { CompanyDuringContractList } from "@/features/company/pages/CompanyDuringContractList";
import { FC } from "react";

const CompanyDuringContractListPage: FC = () => {
  return <CompanyDuringContractList />;
};

export default CompanyDuringContractListPage;
